/* eslint-disable camelcase */

import { Container } from "react-bootstrap";
import PropTypes from "prop-types";
import { useMemo } from "react";

import EmpathcyCompassionAssessment from "../components/EmpathcyCompassionAssessment";
import NextPrevLinks from "../../components/NextPrevLinks";
import ScaleBarChart from "../components/ScaleBarChart";
import SectionIntroduction from "../components/SectionIntroduction";
import { useReport } from "../ReportContext";
import { useUser } from "../../UserContext";

const EmpathyCompassion = ({ showHeader }) => {
	const { respondent } = useUser();
	const { reportContent: { acf: { empathy_compassion } } } = useReport();

	const percentiles = useMemo(() => respondent?.weqProfile?.percentiles, [respondent]);

	return (
		<>
			{showHeader ? <><h1>Your Empathy & Compassion</h1><hr /></> : null}
			<div className="report-view">
				<SectionIntroduction
					text={empathy_compassion?.introduction}
					videoUrl={`https://fast.wistia.net/embed/iframe/r6pkltf6ib`}
				/>
				<hr />
				<section>
					<h2>Information about your Empathy Compassion</h2>
					<Container className="bg-white d-flex flex-column gap-3 rounded-3 my-4">
						<ScaleBarChart value={percentiles?.eMC_sub_WTFS} />
					</Container>
					
					<EmpathcyCompassionAssessment />

					<NextPrevLinks />
				</section>
			</div>
		</>
	);
};

EmpathyCompassion.propTypes = {
	showHeader: PropTypes.bool
};

EmpathyCompassion.defaultProps = {
	showHeader: false
};

export default EmpathyCompassion;
